import { AccessPermissionsEnum } from '@/router/constants';

function load(component) {
  return () => import(`@/views/${component}.vue`);
}

export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: load('dashboard/Dashboard'),
    meta: {
      requiresAuth: true,
      roles: ['operator', 'admin'],
      accessPermissions: [
        AccessPermissionsEnum.CAN_READ_MAIN,
        AccessPermissionsEnum.CAN_READ_MAIN_STATISTICS_WIDGETS,
      ],
      icon: 'home',
    },
    children: [],
  },
];
